import { createAsyncThunk } from '@reduxjs/toolkit';
import type { 
  UserProfile, 
  UpdateUserRequest, 
  UpdateUserResponse, 
  PatchUserRequest, 
  PatchUserResponse,
  SearchUsersRequest,
  SearchUsersResponse,
  CreateUserRequest,
  CreateUserResponse,
  GetUserRequest,
  GetUserResponse
} from '../Domain/entity/UserTypes';
import { userUseCases } from './userUseCases';

export const getUserDetails = createAsyncThunk<UserProfile, string, { rejectValue: string }>(
  'user/getUserDetails',
  async (userId, { rejectWithValue }) => {
    try {
      return await userUseCases.getUserDetails.execute(userId);
    } catch (error) {
      return rejectWithValue((error as Error).message ?? '사용자 정보 조회 실패');
    }
  }
);

export const updateUser = createAsyncThunk<UpdateUserResponse, UpdateUserRequest, { rejectValue: string }>(
  'user/updateUser',
  async (request, { rejectWithValue }) => {
    try {
      return await userUseCases.updateUser.execute(request);
    } catch (error) {
      return rejectWithValue((error as Error).message ?? '사용자 정보 저장 실패');
    }
  }
);

export const patchUser = createAsyncThunk<PatchUserResponse, PatchUserRequest, { rejectValue: string }>(
  'user/patchUser',
  async (request, { rejectWithValue }) => {
    try {
      return await userUseCases.patchUser.execute(request);
    } catch (error) {
      return rejectWithValue((error as Error).message ?? '사용자 정보 수정 실패');
    }
  }
);

export const searchUsers = createAsyncThunk<SearchUsersResponse, SearchUsersRequest, { rejectValue: string }>(
  'user/searchUsers',
  async (request, { rejectWithValue }) => {
    try {
      return await userUseCases.searchUsers.execute(request);
    } catch (error) {
      return rejectWithValue((error as Error).message ?? '사용자 검색 실패');
    }
  }
);

export const createUser = createAsyncThunk<CreateUserResponse, CreateUserRequest, { rejectValue: string }>(
  'user/createUser',
  async (request, { rejectWithValue }) => {
    try {
      return await userUseCases.createUser.execute(request);
    } catch (error) {
      return rejectWithValue((error as Error).message ?? '사용자 생성 실패');
    }
  }
);

export const getUser = createAsyncThunk<GetUserResponse, GetUserRequest, { rejectValue: string }>(
  'user/getUser',
  async (request, { rejectWithValue }) => {
    try {
      return await userUseCases.getUser.execute(request);
    } catch (error) {
      return rejectWithValue((error as Error).message ?? '사용자 조회 실패');
    }
  }
);

